import { gql } from '@apollo/client';

export const ALL_SUBMARKETS_QUERY_NAME = 'AllSubmarkets';
export const ALL_SUBMARKETS = gql`
    query ${ALL_SUBMARKETS_QUERY_NAME}(
    $page: Int,
    $perPage: Int,
    $query: String,
    $sortKey: String,
    $sortDirection: String,
    $includeDeactivated: Boolean,
    $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allSubmarkets(
            page: $page,
            perPage: $perPage,
            query: $query,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            includeDeactivated: $includeDeactivated,
            valueMapping: $valueMapping,
        ) {
            totalCount
            models {
                id
                name
                code
                active
                deactivationBlockers
                modificationBlockers {
                    blockerConstants
                    nonModifiableFields
                }
            }
        }
    }
`;

export const UPDATE_SUBMARKET = gql`
    mutation UpdateSubmarket(
        $id: Int!,
        $code: String!,
        $name: String!,
        $correlationId: String!
    ) {
        updateSubmarket(
            id: $id,
            code: $code,
            name: $name,
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const CREATE_SUBMARKET = gql`
    mutation CreateSubmarket(
        $code: String!,
        $name: String!,
        $correlationId: String!
    ) {
        createSubmarket(
            code: $code,
            name: $name,
            correlationId: $correlationId
        ) {
            id
            name
            code
        }
    }
`;

export const TOGGLE_SUBMARKET_ACTIVATION = gql`
    mutation ToggleSubmarketActivation(
        $id: Int!,
        $correlationId: String!,
    ) {
        toggleSubmarketActivation(
            id: $id,
            correlationId: $correlationId,
        ) {
            name
            code
            active
        }
    }
`;

export const ON_SUBMARKET_CHANGED = gql`
    subscription onSubmarketChanged {
        submarketChanged {
            correlationId
            action
            model {
                id
                name
                code
            }
        }
    }
`;
